import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "overflow-hide" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center flex-wrap" }
const _hoisted_3 = { class: "d-flex align-items-center py-3" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mr-2 text-muted" }, "loading...", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "spinner mr-10" }, null, -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "d-flex align-items-center gap-2 gap-lg-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_a_btn_sm = _resolveComponent("a-btn-sm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_pagination, {
          "current-page": $setup.pagination.page,
          "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (($setup.pagination.page) = $event)),
          onCurrentChange: $setup.PageTo,
          "page-sizes": [12, 24, 50, 100, 150, 200],
          layout: "prev, pager, next",
          total: $setup.pagination.total,
          "hide-on-single-page": true,
          background: ""
        }, null, 8, ["current-page", "onCurrentChange", "total"]),
        ($props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        ($props.btnAddTo)
          ? (_openBlock(), _createBlock(_component_a_btn_sm, {
              key: 0,
              to: $props.btnAddTo,
              text: $props.btnAddLable,
              icon: "fa fa-plus"
            }, null, 8, ["to", "text"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
}